/**
 * Load more component
 */

(function($,undefined){
    $(document).on('click', 'a[data-msp-lm-button]', function(event) {
        event.preventDefault();

        if (!$('[data-msp-lm-target]').length) {
            console.warn( 'Load more target not found' );
            return false;
        }

        var $button       = $(event.currentTarget),
            type          = $button.data('msp-lm-type'),
            term_ids      = $button.data('msp-lm-term-ids'),
            custom_values = $button.data('msp-lm-custom-values'),
            loading_text  = $button.data('msp-lm-loading-text'),
            normal_text   = $button.text(),
            offset        = $button.data('msp-lm-offset'),
            progress_current   = $button.parent().find('[data-msp-lm-progress] .current');

        $button.html(loading_text);
        $button.removeClass( 'has-error' );
        $button.addClass( 'is-loading' );

        $.ajax({
            url      : msp_ajax_url,
            data     : {
                action: 'msp_load_more_posts',
                type: type,
                offset: offset,
                term_ids: term_ids,
                custom_values: custom_values
            },
            type     : 'POST',
            dataType : 'json'
        }).done(function(response) {
            
            $button.html('<span>' + normal_text + '</span>');
            $button.removeClass( 'is-loading' );

            if (true !== response.success || 0 === response.data.posts_total) {
                $button.addClass( 'has-error' );
                console.warn( 'No posts found' );
                return;
            }

            $('[data-msp-lm-target]').append(response.data.posts);

            update_counter(response.data);

            var new_offset = offset + response.data.posts_per_page;
            if (typeof $button.data( 'msp-lm-offset' ) !== 'undefined') {
                $button.data( 'msp-lm-offset', new_offset );
            }

            if (new_offset >= parseInt(response.data.posts_total)) {
                $button.remove();
            }

            // Update new offset in progress counter
            if (progress_current) {
                if (new_offset > response.data.posts_total) {
                    $(progress_current).text(response.data.posts_total);
                } else {
                    $(progress_current).text(new_offset);
                }
            }

            // Update new offset in URL
            $($button).attr('href', updateUrlParameter($button.attr('href'), 'offset', String(new_offset)));
        });
    });

    function update_counter(data)
    {
        var counter = $('[data-msp-lm-counter]');
        var count = counter.data('msp-lm-counter') + data.posts_found;

        counter.html(count).data('msp-lm-counter', count);
    }

    function updateUrlParameter(uri, key, value) {
        const url = new URL(uri);
        url.searchParams.set(key, value);

        return url.toString();
    }

})(jQuery);

